import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getUserWorkgroupsAcl = async (userId, workgroupFilter) => {
    const urlParams = createUrlParams(workgroupFilter);
    const url = `/api/v1/acl/users/${userId}/workgroups?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const createWorkgroupRule = async (workgroupId, data) => {
    const url = `/api/v1/acl/workgroups/${workgroupId}/access_rules`;
    const res = await axios.post(url, data);
    return res.data;
}

export const deleteWorkgroupRule = async (ruleId) => {
    const url = `/api/v1/acl/workgroups/access_rules/${ruleId}`;
    const res = await axios.delete(url);
    return res.data;
}

export const getUserStationsAcl = async (userId, stationFilter) => {
    const urlParams = createUrlParams(stationFilter);
    const url = `/api/v1/acl/users/${userId}/stations?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getGroupStationsAcl = async (groupId, stationFilter) => {
    const urlParams = createUrlParams(stationFilter);
    const url = `/api/v1/acl/groups/${groupId}/stations?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const createStationRule = async (stationId, data) => {
    const url = `/api/v1/acl/stations/${stationId}/access_rules`;
    const res = await axios.post(url, data);
    return res.data;
}

export const deleteStationRule = async (ruleId) => {
    const url = `/api/v1/acl/stations/access_rules/${ruleId}`;
    const res = await axios.delete(url);
    return res.data;
}

export const getStationAcl = async (stationId, userFilter) => {
    const urlParams = createUrlParams(userFilter);
    const url = `/api/v1/acl/stations/${stationId}?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getWorkgroupAcl = async (workgroupId, userFilter) => {
    const urlParams = createUrlParams(userFilter);
    const url = `/api/v1/acl/workgroups/${workgroupId}?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}